export const FETCH_DRUG_CHART_SUCCESS = 'FETCH_DRUG_CHART_SUCCESS';
export const FETCH_DRUG_CHART_FAILED ='FETCH_DRUG_CHART_FAILED';
export const FETCH_DRUG_CHART_START = 'FETCH_DRUG_CHART_START';

export const ADMINISTER_MEDICATION_START = 'ADMINISTER_MEDICATION_START';
export const ADMINISTER_MEDICATION_SUCCESS = 'ADMINISTER_MEDICATION_START';
export const ADMINISTER_MEDICATION_FAILED = 'ADMINISTER_MEDICATION_FAILED';
